/*
  main-article-mc.js
  - Side nav: auto-builds its list from the H2 headings actually present
    in the rendered article content (no per-article configuration).
    Adds ids to headings that don't already have one. Highlights the
    active link via IntersectionObserver as the user scrolls.
  - CTA drawer: simple expand/collapse toggle.
*/

(function () {
  function slugify(text, index) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    return base ? base + '-' + index : 'section-' + index;
  }

  function initSideNav() {
    var nav = document.querySelector('[data-side-nav-mc]');
    var contentEl = document.querySelector('.article-template-mc__content');
    if (!nav || !contentEl) return;

    var headings = contentEl.querySelectorAll('h2');
    if (!headings.length) {
      nav.hidden = true;
      return;
    }

    var list = nav.querySelector('[data-side-nav-list]');
    if (!list) return;

    var links = [];
    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, index);
      }
      var li = document.createElement('li');
      li.className = 'side-nav-mc__item';
      var a = document.createElement('a');
      a.className = 'side-nav-mc__link';
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      a.title = heading.textContent;
      a.dataset.spy = heading.id;
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = nav.querySelector('.side-nav-mc__link[data-spy="' + entry.target.id + '"]');
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (l) {
              l.classList.remove('is-active');
            });
            link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  function initCtaDrawer() {
    var drawer = document.querySelector('[data-cta-drawer-mc]');
    if (!drawer) return;

    // Move to a direct child of <body> so `position: fixed` is always
    // relative to the viewport. Any ancestor with a `transform`
    // (Dawn's scroll-reveal animations, gradient background effects,
    // etc.) would otherwise re-scope `fixed` to that ancestor instead
    // of the viewport, breaking the anchoring.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    var toggle = drawer.querySelector('[data-cta-drawer-toggle]');
    var body = drawer.querySelector('[data-cta-drawer-body]');
    if (!toggle || !body) return;

    toggle.addEventListener('click', function () {
      var isOpen = drawer.classList.toggle('is-open');
      body.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initCtaDrawerFooterRaise() {
    var drawer = document.querySelector('[data-cta-drawer-mc]');
    var footer = document.querySelector('footer');
    if (!drawer || !footer || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          drawer.classList.toggle('is-raised', entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(footer);
  }

  function initCopyLink() {
    var buttons = document.querySelectorAll('[data-copy-link]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      var textEl = button.querySelector('[data-copy-text]');
      var url = button.dataset.copyUrl;
      var labelDefault = button.dataset.copyLabel || 'Copy link';
      var labelDone = button.dataset.copyLabelDone || 'Link copied!';
      var resetTimer;

      button.addEventListener('click', function () {
        if (!url || !navigator.clipboard) return;

        navigator.clipboard.writeText(url).then(function () {
          if (textEl) textEl.textContent = labelDone;
          button.classList.add('is-copied');
          clearTimeout(resetTimer);
          resetTimer = setTimeout(function () {
            if (textEl) textEl.textContent = labelDefault;
            button.classList.remove('is-copied');
          }, 2000);
        });
      });
    });
  }

  function initScrollToFooter() {
    var links = document.querySelectorAll('[data-scroll-to-footer]');
    if (!links.length) return;

    var footer = document.querySelector('.veneera-footer');
    if (!footer) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSideNav();
    initCtaDrawer();
    initCtaDrawerFooterRaise();
    initCopyLink();
    initScrollToFooter();
  });
})();
